import React from 'react'

const ExpandSession = props => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M8.00016 1.33325C4.32683 1.33325 1.3335 4.32659 1.3335 7.99992C1.3335 11.6733 4.32683 14.6666 8.00016 14.6666C11.6735 14.6666 14.6668 11.6733 14.6668 7.99992C14.6668 4.32659 11.6735 1.33325 8.00016 1.33325ZM10.6668 8.49992H8.50016V10.6666C8.50016 10.9399 8.2735 11.1666 8.00016 11.1666C7.72683 11.1666 7.50016 10.9399 7.50016 10.6666V8.49992H5.3335C5.06016 8.49992 4.8335 8.27325 4.8335 7.99992C4.8335 7.72659 5.06016 7.49992 5.3335 7.49992H7.50016V5.33325C7.50016 5.05992 7.72683 4.83325 8.00016 4.83325C8.2735 4.83325 8.50016 5.05992 8.50016 5.33325V7.49992H10.6668C10.9402 7.49992 11.1668 7.72659 11.1668 7.99992C11.1668 8.27325 10.9402 8.49992 10.6668 8.49992Z'
      fill='#B64FCD'
    />
  </svg>
)

export default ExpandSession
